<article class="">
    <header class="">
        <div class="">
            <ul class="list-inline d-flex justify-content-between mb-0">
                <li class="list-inline-item">
                    <h1 class="">Contract Length</h1>
                </li>
                <li class="list-inline-item">
                    <button class="btn btn-icon btn-light-info mx-1" (click)="printPage()">
                        <i class="ti ti-printer"></i>
                    </button>
                    <button aria-label="Copy link" class="btn btn-icon btn-light-info" (click)="copyFullPageText()">
                        <i class="ti ti-copy"></i>
                    </button>
                </li>
            </ul>
        </div>
    </header>
    <div class=""> 
        <div class="card-body p-2" data-testid="article-body" dir="auto">
            <p class="mt-1">Xeneta aggregates ocean freight rates for both <strong>short term</strong> and <strong>long term</strong>
                contracts.</p>
            <blockquote class="my-4 p-3 bg-gray-200 color-block">
                <p class="m-0">Due to industry specifics, short and long-term contracts have different definitions in
                    ocean and air freight.</p>
            </blockquote>
            <ul>
                <li class="my-4">Short-term — any contract that is valid for <strong>less than&nbsp;</strong><strong>32 days</strong>
                </li>
                <li class="my-4">Long-term — any contract that is valid for <strong>longer than&nbsp;</strong><strong>87
                        days</strong></li>
            </ul>
            <p>To keep rates as comparable as possible, short-term and long-term rates are never aggregated together.
            </p>
            <blockquote class="my-4 p-3 bg-gray-200 color-block">
                <p class="m-0">For additional information about contracted rates, see 
                        <span class="text-primary cursor-pointer" (click)="goToContractedWithin()">Contracted
                            Within</span>.</p>
            </blockquote>
        </div>
    </div>
</article>